{
  "en": {
    "company": {
      "actions": {
        "changeCompany": "Change organisation",
        "searchCompany": "Search organisation"
      },
      "attributes": {
        "address": "Address",
        "email_address": "Email",
        "iban": "IBAN",
        "language": "Language",
        "name": "Organisation name",
        "phone": "Phone",
        "subdomain": "Subdomain",
        "vat": "VAT"
      },
      "labels": {
        "company": "Organisation",
        "contact": "Contact",
        "contacts": "Contacts",
        "language": "This is the organisation's default language for your login page, customers and team members.",
        "or": "OR"
      },
      "validation": {
        "contactAlreadyExist": "Contact already exists. Please select from the dropdown.",
        "mustBeEmailAddress": "Valid email address required",
        "needName": "Name is required"
      }
    }
  }
}
